import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const ProgressTrack = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${COLORS.bgTertiary};
`

export const ProgressFill = styled.div`
  height: 100%;
  background-color: ${COLORS.brand};
  transition: width 200ms ease-out;
`
